// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__bd3ZT","left":"styles_left__WB5DY","logoLink":"styles_logoLink__7_7jW","logo":"styles_logo__OPbWM"};